const layerDynamicsItems = [];
export default layerDynamicsItems;
